import i18n from "@/i18n";
import { LocaleMessage } from "vue-i18n";

export default class StyledBox {

  public static get styledBoxOptions(): StyledBoxOptions[] {
    return [
      {
        // text: i18n.t('filters.typeFilter.swapBox'),
        text: 'Swap Box',
        value: 'swap_box',
      },
      {
        // text: i18n.t('filters.typeFilter.styledBox'),
        text: 'Styled box',
        value: 'styled_box',
      },
      {
        // text: i18n.t('filters.typeFilter.studio'),
        text: 'Studio',
        value: 'studio',
      },
      {
        // text: i18n.t('filters.typeFilter.afterSales'),
        text: 'After Sales',
        value: 'after_sales',
      },
      {
        // text: i18n.t('filters.typeFilter.promotion'),
        text: 'Promotion',
        value: 'promotion',
      },
      {
        // text: i18n.t('filters.typeFilter.supplierReturn'),
        text: 'Supplier Return',
        value: 'supplier_return',
      },
      {
        // text: i18n.t('filters.typeFilter.swipeToShop'),
        text: 'Swipe-to-shop',
        value: 'swipe_to_shop',
      },
      {
        // text: i18n.t('filters.typeFilter.shopify'),
        text: 'Shopify',
        value: 'shopify',
      },
      {
        // text: i18n.t('filters.typeFilter.stylingFee'),
        text: 'Styling fee',
        value: 'styling_fee',
      },
      {
        // text: i18n.t('filters.typeFilter.other'),
        text: 'Other',
        value: 'other',
      },
    ];
  }
}


export interface StyledBoxOptions {
  text?: string | LocaleMessage;
  value?: string;
}
